import { render } from "./ProfitLossAnalyticsTable.vue?vue&type=template&id=7b636ff4&scoped=true"
import script from "./ProfitLossAnalyticsTable.vue?vue&type=script&lang=js"
export * from "./ProfitLossAnalyticsTable.vue?vue&type=script&lang=js"

import "./ProfitLossAnalyticsTable.vue?vue&type=style&index=0&id=7b636ff4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b636ff4"]])

export default __exports__